import { componentRegistry } from "./component_registry";

export function loadComponents() {
  Object.entries(componentRegistry).forEach(([name, init]) => {
    const selector = `[data-component="${name}"]:not([data-initialized])`;

    // TODO: usar new Set para evitar duplicados de inicialización
    document.querySelectorAll<HTMLElement>(selector).forEach(element => {
      element.dataset.initialized = "true";
      init(element);
    });
  });
}
